import {
  AnnualTax,
  AnnualTaxEditFormValues,
  AnnualTaxRow,
} from "./types";

/*---------------------------------------------------------------------------------------
  CALCULATION ANNUAL TAX
-----------------------------------------------------------------------------------------*/

export const transformAnnualTax = (
  res: any
): AnnualTax => {
  return {
    id: res.id,
    fromKw: res.fromKw,
    toKw: res.toKw,
    price: res.price,
  };
};

/*---------------------------------------------------------------------------------------
  CALCULATION ANNUAL TAX SEARCH
-----------------------------------------------------------------------------------------*/

export const transformAnnualTaxRow = (
  res: any
): AnnualTaxRow => {
  return {
    id: res.id,
    fromKw: res.fromKw,
    toKw: res.toKw,
    price: res.price,
  };
};

/*---------------------------------------------------------------------------------------
    CALCULATION ANNUAL TAX CREATE
  -----------------------------------------------------------------------------------------*/

export const transformAnnualTaxOnCreate = (
  formValues: AnnualTaxEditFormValues
): any => ({
  fromKw: formValues.fromKw,
  toKw: formValues.toKw,
  price: formValues.price,
});

/*---------------------------------------------------------------------------------------
  CALCULATION ANNUAL TAX EDIT
-----------------------------------------------------------------------------------------*/

export const transformAnnualTaxOnUpdate = (
  formValues: AnnualTaxEditFormValues
): any => ({
  id: formValues.id,
  fromKw: formValues.fromKw,
  toKw: formValues.toKw,
  price: formValues.price,
});
